/**
 * Signalements (trust & safety), in French, the reference language. Merged
 * into fr.ts; every other language has a reports.<lang>.ts with the same keys.
 * A suspension lasts until a staff decision: its review deadline is never an
 * expiry, and nothing here may say it ends by itself.
 */
export const reportsFr = {
  "reports.filter.severity": "Gravité",
  "reports.filter.status": "Statut",
  "reports.filter.all": "Tous",
  "reports.filter.reviewOverdue": "Revue de suspension en retard",
  "reports.list.loading": "Chargement des signalements…",
  "reports.list.loadFailed": "Impossible de charger les signalements.",
  "reports.list.empty": "Aucun signalement pour ces filtres.",
  "reports.list.aria": "Signalements",
  "reports.list.by": "signalé par {name}",
  "reports.list.aboutSubject": "{count} signalements sur cette personne",
  "reports.pick": "Choisissez un signalement dans la liste.",
  "reports.loading": "Chargement du signalement…",
  "reports.loadFailed": "Impossible de charger ce signalement.",
  "reports.notFound": "Ce signalement est introuvable. Rechargez la liste.",
  "reports.refreshFailed": "Le signalement n'a pas pu être actualisé : il est affiché tel qu'il était.",
  "reports.dismiss": "Fermer",

  "reports.severity.critical": "Critique",
  "reports.severity.high": "Élevée",
  "reports.severity.medium": "Moyenne",
  "reports.severity.low": "Faible",
  "reports.status.open": "Ouvert",
  "reports.status.investigating": "En enquête",
  "reports.status.decided": "Tranché",
  "reports.status.appealed": "En appel",
  "reports.status.closed": "Clos",
  "reports.verdict.none": "Aucune sanction",
  "reports.verdict.warning": "Avertissement",
  "reports.verdict.temporary_suspension": "Suspension temporaire",
  "reports.verdict.permanent_ban": "Bannissement définitif",
  "reports.appeal.upheld": "Décision maintenue",
  "reports.appeal.overturned": "Décision annulée",
  "reports.source.app": "Depuis l'application",
  "reports.source.phone": "Par téléphone",
  "reports.source.console": "Ouvert par l'équipe",

  "reports.category.assault": "Agression",

  "reports.new.title": "Nouveau signalement",

  "reports.new.source": "Comment il nous est parvenu",

  "reports.new.byPhone": "Par téléphone",

  "reports.new.byStaff": "Constaté par l'équipe",

  "reports.new.subject": "Personne signalée",

  "reports.new.reporter": "Personne à l'origine du signalement",

  "reports.new.reporterHint":
    "Son identifiant, si un client a signalé. Laissez vide si l'équipe l'a constaté ou si l'appelant n'est pas client.",

  "reports.new.category": "Ce qui s'est passé",

  "reports.new.categoryHint": "La gravité en découle. Modifiez-la ensuite si c'est plus grave.",

  "reports.new.description": "Ce qui nous a été dit",

  "reports.new.descriptionHint": "Avec ses mots autant que possible. C'est ce que lira la personne qui enquête.",

  "reports.new.submit": "Ouvrir le signalement",

  "reports.new.needSubject": "Choisissez la personne signalée.",

  "reports.new.needDescription": "Décrivez ce qui s'est passé, au moins en une phrase.",

  "reports.new": "Nouveau signalement",
  "reports.category.sexual_violence": "Violence sexuelle",
  "reports.category.serious_theft": "Vol grave",
  "reports.category.weapon_threat": "Menace avec une arme",
  "reports.category.theft": "Vol",
  "reports.category.threats": "Menaces",
  "reports.category.harassment": "Harcèlement",
  "reports.category.fraud": "Fraude",
  "reports.category.unsafe_work": "Travail dangereux",
  "reports.category.no_show": "Absence au rendez-vous",
  "reports.category.other": "Autre",

  "reports.pill.suspended": "Suspendu",
  "reports.pill.reviewOverdue": "Revue en retard",
  "reports.pill.legalHold": "Gel légal",

  "reports.detail.versionTitle": "La version du signalement affichée : chaque action l'envoie.",
  "reports.detail.critical": "Signalement critique",
  "reports.detail.needsPolice": "Il n'a pas encore été transmis à la police. Les propriétaires ont été prévenus.",
  "reports.detail.subject": "Personne signalée",
  "reports.detail.reporter": "Auteur du signalement",
  "reports.detail.openedBy": "Ouvert par {name}",
  "reports.detail.noReporter": "Inconnu",
  "reports.detail.job": "Demande liée",
  "reports.detail.case": "Dossier d'origine",
  "reports.detail.subjectCase": "Dossier de la personne signalée",
  "reports.detail.openCase": "Ouvrir le dossier →",
  "reports.detail.noSubjectCase": "Aucun : il s'ouvre à la suspension ou à l'appel",
  "reports.detail.none": "Aucun",
  "reports.detail.description": "Ce qui s'est passé",
  "reports.detail.restrictions": "Suspensions et bannissements",
  "reports.detail.restrictionsHint":
    "Une suspension dure jusqu'à une décision de l'équipe. Le délai de revue n'est pas une fin : passé ce délai, la personne reste suspendue et la revue est en retard.",
  "reports.detail.verdict": "Verdict",
  "reports.detail.decidedBy": "Par {name}, le {date}",
  "reports.detail.appeal": "Appel",
  "reports.detail.appealedAt": "Appel reçu le {date}",
  "reports.detail.appealPending": "À trancher",
  "reports.detail.police": "Transmissions à la police",
  "reports.detail.shared": "Données remises : {categories} · {name}, {date}",
  "reports.detail.holds": "Gels légaux",
  "reports.detail.holdPlaced": "En place depuis le {date} · {name}",
  "reports.detail.holdReleased": "Levé le {date} · {name}",
  "reports.detail.related": "Autres signalements sur cette personne",
  "reports.detail.timeline": "Chronologie",
  "reports.detail.actions": "Actions",
  "reports.detail.noActions": "Aucune action possible avec vos rôles sur ce signalement.",

  "reports.restriction.interim_suspension": "Suspension pendant l'enquête",
  "reports.restriction.temporary_suspension": "Suspension temporaire",
  "reports.restriction.permanent_ban": "Bannissement définitif",
  "reports.restriction.untilDecision": "Jusqu'à décision de l'équipe",
  "reports.restriction.untilDecisionReviewBy": "Jusqu'à décision de l'équipe · à revoir avant le {date}",
  "reports.restriction.until": "Jusqu'au {date}",
  "reports.restriction.permanent": "Définitif, sauf appel accepté",
  "reports.restriction.switchedOff": "Coupé : {features}",
  "reports.restriction.lifted": "Levée le {date} par {name}",
  "reports.restriction.inForce": "En vigueur",
  "reports.restriction.ended": "Terminée",

  "reports.entry.report": "Signalement",
  "reports.entry.evidence": "Preuve",
  "reports.entry.severity_changed": "Gravité changée",
  "reports.entry.suspended": "Suspension",
  "reports.entry.suspension_lifted": "Suspension levée",
  "reports.entry.verdict": "Verdict",
  "reports.entry.appeal": "Appel",
  "reports.entry.appeal_decided": "Appel tranché",
  "reports.entry.police_referral": "Transmis à la police",
  "reports.entry.police_data_shared": "Données remises à la police",
  "reports.entry.legal_hold_placed": "Gel légal posé",
  "reports.entry.legal_hold_released": "Gel légal levé",
  "reports.entry.linked": "Lien ajouté",
  "reports.entry.suspension_withheld": "Suspension non appliquée",
  "reports.entry.system": "Système",
  "reports.entry.evidenceLink": "Voir la pièce →",

  "reports.police.category.identity": "Identité",
  "reports.police.category.contact_details": "Coordonnées",
  "reports.police.category.id_document": "Pièce d'identité",
  "reports.police.category.messages": "Messages",
  "reports.police.category.job_details": "Détails de la demande",
  "reports.police.category.report_and_evidence": "Signalement et preuves",
  "reports.police.category.audit_log": "Journal d'audit",
  "reports.police.category.payments": "Paiements",
  "reports.hold.entity.safety_report": "Ce signalement",
  "reports.hold.entity.user": "Le compte",
  "reports.hold.entity.job": "La demande",
  "reports.hold.entity.conversation": "La conversation",

  "reports.block.ownVerdict": "Vous avez rendu le verdict : quelqu'un d'autre doit trancher l'appel.",
  "reports.block.ownerOnly": "Seul un propriétaire peut remettre des données à la police.",
  "reports.block.noReferral": "Transmettez d'abord le signalement à la police pour noter les données remises.",

  "reports.action.evidence": "Ajouter une preuve",
  "reports.action.severity": "Changer la gravité",
  "reports.action.suspend": "Suspendre pendant l'enquête",
  "reports.action.lift": "Lever la suspension",
  "reports.action.verdict": "Rendre le verdict",
  "reports.action.ban": "Bannir définitivement",
  "reports.action.appeal": "Trancher l'appel",
  "reports.action.police": "Transmettre à la police",
  "reports.action.share": "Noter des données remises",
  "reports.action.hold": "Poser un gel légal",
  "reports.action.release": "Lever le gel légal",

  "reports.dialog.evidence.title": "Ajouter une preuve · {reference}",
  "reports.dialog.evidence.body":
    "Décrivez la pièce et, si elle est en ligne, donnez son lien. Elle rejoint la chronologie.",
  "reports.dialog.severity.title": "Changer la gravité · {reference}",
  "reports.dialog.severity.body":
    "Un signalement critique prévient les propriétaires et doit être transmis à la police. Dites pourquoi vous changez.",
  "reports.dialog.suspend.title": "Suspendre · {reference}",
  "reports.dialog.suspend.body":
    "{name} ne pourra plus utiliser Walliyo, sauf contacter l'équipe et faire appel, jusqu'à une décision de l'équipe. Un délai de revue s'applique : ce n'est pas une fin de suspension. La personne est prévenue dans l'application et un dossier s'ouvre à son nom.",
  "reports.dialog.lift.title": "Lever la suspension · {reference}",
  "reports.dialog.lift.body": "{name} retrouve l'accès à Walliyo dès maintenant. Dites pourquoi.",
  "reports.dialog.verdict.title": "Rendre le verdict · {reference}",
  "reports.dialog.verdict.body":
    "Le motif est lu par {name} dans l'application, avec la possibilité de faire appel une fois. Personne n'est sanctionné sans motif écrit.",
  "reports.dialog.ban.title": "Bannir définitivement · {reference}",
  "reports.dialog.ban.body":
    "{name} perd l'accès à Walliyo pour de bon, et sa pièce d'identité est bannie. Le motif lui est montré dans l'application ; il peut faire appel une fois.",
  "reports.dialog.appeal.title": "Trancher l'appel · {reference}",
  "reports.dialog.appeal.body":
    "Annulée lève ce que le verdict a mis en place. {name} lit votre motif dans l'application. Quelqu'un d'autre que l'auteur du verdict doit trancher.",
  "reports.dialog.police.title": "Transmettre à la police · {reference}",
  "reports.dialog.police.body": "Notez à qui le signalement a été transmis. Rien n'est envoyé d'ici.",
  "reports.dialog.share.title": "Données remises à la police · {reference}",
  "reports.dialog.share.body":
    "Notez exactement ce qui a été remis, catégorie par catégorie. Cette trace est gardée et figure dans le journal d'audit.",
  "reports.dialog.hold.title": "Poser un gel légal · {reference}",
  "reports.dialog.hold.body":
    "Rien de ce qui touche ce signalement ne pourra être supprimé tant que le gel est en place, même par la règle de conservation.",
  "reports.dialog.release.title": "Lever le gel légal · {reference}",
  "reports.dialog.release.body": "Les règles de conservation s'appliquent de nouveau à tout ce que le gel protégeait.",

  "reports.field.evidence": "La preuve",
  "reports.field.evidenceUrl": "Lien (facultatif)",
  "reports.field.evidenceUrlHint": "Une adresse https://, par exemple une photo déposée dans le dossier.",
  "reports.field.severity": "Nouvelle gravité",
  "reports.field.verdict": "Verdict",
  "reports.field.suspendedUntil": "Suspendu jusqu'au",
  "reports.field.toldReason": "Motif lu par la personne",
  "reports.field.toldHint": "Une vraie phrase, dans des mots que la personne comprend. Au moins 10 caractères.",
  "reports.field.decision": "Décision",
  "reports.field.station": "Commissariat ou brigade",
  "reports.field.officerName": "Nom de l'agent",
  "reports.field.officerContact": "Contact de l'agent (facultatif)",
  "reports.field.policeReference": "Référence de la police (facultatif)",
  "reports.field.referral": "Transmission",
  "reports.field.categories": "Données remises",
  "reports.field.shareDescription": "Ce qui a été remis, exactement",
  "reports.field.shareDescriptionHint": "Par exemple : messages du 3 au 5 mai, scan de la carte d'identité.",
  "reports.field.reasonOptional": "Motif (facultatif)",

  "reports.problem.reason": "Donnez un motif de {min} à {max} caractères.",
  "reports.problem.told": "Écrivez le motif lu par la personne : au moins {min} caractères.",
  "reports.problem.evidence": "Décrivez la preuve.",
  "reports.problem.url": "Le lien doit être une adresse http:// ou https:// complète.",
  "reports.problem.until": "Choisissez une date de fin de suspension dans le futur.",
  "reports.problem.police": "Indiquez le commissariat et le nom de l'agent (2 à 200 caractères chacun).",
  "reports.problem.referral": "Choisissez la transmission concernée.",
  "reports.problem.categories": "Cochez au moins une catégorie de données remises.",
  "reports.problem.shareDescription": "Dites exactement ce qui a été remis.",

  "reports.done.evidence": "Preuve ajoutée à {reference}.",
  "reports.done.severity": "Gravité de {reference} changée.",
  "reports.done.suspend":
    "Personne suspendue jusqu'à décision de l'équipe ({reference}). Elle est prévenue dans l'application.",
  "reports.done.lift": "Suspension levée ({reference}).",
  "reports.done.verdict": "Verdict enregistré sur {reference}. La personne est prévenue dans l'application.",
  "reports.done.ban": "Bannissement enregistré sur {reference}. La personne est prévenue dans l'application.",
  "reports.done.appeal": "Appel tranché sur {reference}. La personne est prévenue dans l'application.",
  "reports.done.police": "Transmission à la police notée sur {reference}.",
  "reports.done.share": "Données remises notées sur {reference}.",
  "reports.done.hold": "Gel légal posé sur {reference}.",
  "reports.done.release": "Gel légal levé sur {reference}.",

  "reports.error.stale":
    "Ce signalement a changé pendant que vous le regardiez. Rechargez-le, vérifiez, puis recommencez.",
  "reports.error.refused":
    "Action refusée : vos rôles n'incluent pas la fonctionnalité nécessaire. Demandez l'accès à un responsable.",
  "reports.error.appealRefused":
    "Refusé : l'appel doit être tranché par quelqu'un d'autre que l'auteur du verdict, avec HANDLE_APPEALS.",
  "reports.error.shareRefused": "Refusé : seul un propriétaire peut remettre des données à la police.",
  "reports.error.invalid":
    "Refusé : le signalement n'est plus dans l'état voulu, ou un champ est invalide. Rechargez-le et vérifiez.",
  "reports.error.outcomeUnknown":
    "Pas de réponse du serveur : l'action a peut-être été enregistrée. Réessayez : le même clic ne peut pas être appliqué deux fois.",

  "reports.refused.wrongStatus":
    "Refusé : ce signalement n'est plus à cette étape, l'action ne s'applique plus. Rechargez-le.",
  "reports.refused.alreadyRestricted": "Refusé : cette personne est déjà suspendue par un autre signalement.",
  "reports.refused.notSuspended": "Refusé : ce signalement n'a plus de suspension en cours. Rechargez-le.",
  "reports.refused.suspendedUntilRequired": "Une suspension temporaire a besoin d'une date de fin dans le futur.",
  "reports.refused.ownVerdict": "Refusé : vous avez rendu ce verdict, quelqu'un d'autre doit trancher l'appel.",
  "reports.refused.alreadyHeld": "Ce signalement est déjà sous gel légal. Rechargez-le.",
  "reports.refused.notHeld": "Ce signalement n'est plus sous gel légal. Rechargez-le.",
} as const;

export type ReportsMessageId = keyof typeof reportsFr;
